import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  page: {
    backgroundColor: 'var(--grey-100)',
    p: { xs: '16px', md: '32px' },
    borderRadius: '8px'
  } satisfies SxProps<Theme>,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    mb: '16px'
  } satisfies SxProps<Theme>,
  intro: {
    maxWidth: '620px',
    mt: '4px'
  } satisfies SxProps<Theme>,
  backButton: {
    backgroundColor: 'var(--white)',
    whiteSpace: 'nowrap'
  } satisfies SxProps<Theme>,
  card: {
    backgroundColor: 'var(--white)',
    border: '1px solid var(--blue-300)',
    borderRadius: '8px',
    p: { xs: '20px', md: '32px' },
    position: 'relative'
  } satisfies SxProps<Theme>,
  identity: {
    position: { xs: 'static', md: 'absolute' },
    top: { md: '32px' },
    right: { md: '32px' },
    textAlign: 'right',
    mb: { xs: '8px', md: 0 }
  } satisfies SxProps<Theme>
}
